import React from 'react';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { LoadingOutlined } from '@ant-design/icons';
import { Form, useFormikContext } from 'formik';
import { Link } from 'react-router-dom';
import { HOME } from '../../constants/routes';

export const StepButton = (props) => {
  const {
    step, isLoading, onUpdateRegistry, setStep, editFundRequest
  } = props;
  const { values, submitForm } = useFormikContext();
  switch (step) {
    case 1:
      return (
        <div className="onboard-button-wrapper middle">
          <button
              className="onboard-button middle-button"
            disabled={isLoading}
            type="submit"
            onClick={submitForm}
          >
            {isLoading ? <LoadingOutlined /> : null}
            {isLoading ? 'Updating Profile' : 'Next'}
          </button>
        </div>
      );
    case 2:
      return (
        <div className="onboard-button-wrapper">
          <div className="one-button-holder">
            <button
              className="registry-button onboard-button"
              disabled={isLoading}
              type="button"
              onClick={() => setStep(step + 1)}
            >
              {isLoading ? <LoadingOutlined /> : null}
              Create a Registry
            </button>
          </div>
          <button
            type="button"
            className="onboard-button"
            color="primary"
            onClick={() => setStep(step - 1)}
          >
            {isLoading ? <LoadingOutlined /> : null}
            {isLoading ? 'Going Back' : 'Back'}
            {' '}
          </button>
          <button
            className="onboard-button"
            color="primary"
            type="submit"
            onClick={() => setStep(4)}
          >
            Skip for now
          </button>
        </div>
      );
    case 3:
      return (
        <div className="onboard-button-wrapper">
          <button
            type="button"
            className="onboard-button reg"
            color="primary"
            onClick={() => setStep(step - 1)}
          >
            {isLoading ? <LoadingOutlined /> : null}
            {isLoading ? 'Going Back' : 'Back'}
            {' '}
          </button>
          <button
            className="onboard-button reg right"
            color="primary"
            type="submit"
            onClick={onUpdateRegistry}
          >
            {isLoading ? <LoadingOutlined /> : null}
            {isLoading ? 'Saving Registry' : 'Save Registry'}
            {' '}
          </button>
        </div>
      );
    case 5:
      return (
        <div className="onboard-button-wrapper">
          <button
            type="button"
            className="onboard-button"
            color="primary"
            onClick={() => setStep(step - 1)}
          >
            Back
          </button>
          <button
            className="onboard-button"
            color="primary"
            type="button"
            onClick={isLoading? ()=>{} :submitForm}
          >
            {isLoading ? <LoadingOutlined /> : null}
            {isLoading ? '' : editFundRequest ? 'Edit Fund Request' : 'Set Up Payment'}
            {' '}
          </button>
        </div>
      );
    case 6:
      return (
        <div className="onboard-button-wrapper" />
      );
    default:
      return (
        <div className="onboard-button-wrapper" />
      );
  }
};
